import React from 'react';
import PropTypes from 'prop-types';
import {
  AbsoluteContainer,
  Cushion,
  Image,
  Rectangle,
  RelativeContainer,
  Typography,
} from '@pitchero/react-ui';

const ProfileAvatar = ({ avatar, name, hasLeft }) => {
  if (hasLeft) {
    return (
      <RelativeContainer style={{ gridArea: 'avatar' }}>
        <Image
          src={avatar}
          alt={name}
          preset="profile"
          fullWidth
          style={{ display: 'block' }}
          width={120}
          height={120}
        />
        <AbsoluteContainer left={0} bottom={0} right={0}>
          <Rectangle radius="roundedBottom" fill="black" style={{ opacity: 0.9 }}>
            <Cushion all="small">
              <Typography
                preset="tab--active"
                color="white"
                align="center"
                component="div"
                responsive={[{ maxWidth: 'tab', props: { preset: 'tag--large' } }]}
              >
                Former Player
              </Typography>
            </Cushion>
          </Rectangle>
        </AbsoluteContainer>
      </RelativeContainer>
    );
  }
  return (
    <Rectangle radius="rounded" style={{ gridArea: 'avatar' }}>
      <Image src={avatar} alt={name} preset="profile" fullWidth width={120} height={120} />
    </Rectangle>
  );
};

ProfileAvatar.propTypes = {
  avatar: PropTypes.string.isRequired,
  hasLeft: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
};

export default ProfileAvatar;
